import { AppState } from 'mk2/reducers';
import { initialAskQuestionState, AskQuestionState } from './FaqAskQuestion.reducers';

export const getFaqAskQuestionState = (state: AppState, faqId: string): AskQuestionState =>
    state.containers.faq.faqAskQuestion[faqId] || initialAskQuestionState;
